export default (degrees) => {
	return (Math.PI / 180) * (degrees - 90);
};
